import { useRef, useCallback, useState, useEffect } from 'react';
import { RealtimeEvent, useRealtimeClient } from '../utils/useRealtimeClient';
import { useWaveRenderer } from '../utils/useWaveRenderer';
import { useUIScroller } from '../utils/useUIScroller';

const instructions = process.env.REACT_APP_PROMPT;

export function ConsolePage({ authToken }: { authToken: string }) {

  const startTimeRef = useRef<string>(new Date().toISOString());
  const [realtimeEvents, setRealtimeEvents] = useState<RealtimeEvent[]>([]);
  const [memoryKv, setMemoryKv] = useState<{ [key: string]: any }>({
    userName: process.env.REACT_APP_USERNAME,
    todaysDate: new Date().toISOString().split('T')[0],
  });

  const [isFlying, setIsFlying] = useState(false);

  const { eventsScrollRef } = useUIScroller(realtimeEvents);
  const {
    clientCanvasRef,
    serverCanvasRef,
    wavRecorderRef,
    wavStreamPlayerRef,
  } = useWaveRenderer();

  const {
    client,
    isConnected,
    isMuted,
    setIsMuted,
    connectConversation,
    disconnectConversation,
  } = useRealtimeClient(
    startTimeRef,
    setRealtimeEvents,
    wavStreamPlayerRef,
    wavRecorderRef,
    instructions + ' Memory: ' + JSON.stringify(memoryKv, null, 2),
    authToken,
    [
      {
        schema: {
          name: 'set_memory',
          description:
            'Saves important data about the user into memory. If keys are close, prefer overwriting keys rather than creating new keys.',
          parameters: {
            type: 'object',
            properties: {
              key: {
                type: 'string',
                description: process.env.REACT_APP_AGENT_KNOWLEDGE_1,
              },
              value: {
                type: 'string',
                description: process.env.REACT_APP_AGENT_KNOWLEDGE_2,
              },
            },
            required: ['key', 'value'],
          },
        },
        async fn({ key, value }: { key: string; value: string }) {
          setMemoryKv((prev) => ({ ...prev, [key]: value }));
        },
      },
    ]
  );

  const formatTime = useCallback((timestamp: string) => {
    const startTime = startTimeRef.current;
    const t0 = new Date(startTime).valueOf();
    const t1 = new Date(timestamp).valueOf();
    const delta = t1 - t0;
    const hs = Math.floor(delta / 10) % 100;
    const s = Math.floor(delta / 1000) % 60;
    const m = Math.floor(delta / 60_000) % 60;
    const pad = (n: number) => {
      let s = n + '';
      while (s.length < 2) {
        s = '0' + s;
      }
      return s;
    };
    return `${pad(m)}:${pad(s)}.${pad(hs)}`;
  }, []);


  // Detecta Shift + X para iniciar voo e redirecionar
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.shiftKey && event.key.toLowerCase() === 'x') {
        setIsFlying(true);
        setTimeout(() => {
          window.location.href = 'https://portal.es.gov.br/';
        }, 1500); // tempo para animação
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div>
      <img
        src={isConnected ? '/bandes-avatar.gif' : '/bandes-avatar.png'}
        alt="Conectar"
        onClick={isConnected ? disconnectConversation : connectConversation}
        style={{
          position: 'fixed',
          bottom: '180px',
          right: '100px',
          maxHeight: '200px',
          maxWidth: '200px',  
          cursor: 'pointer',
          transition: 'transform 1.5s ease-out, opacity 1.5s',
          transform: isFlying ? 'translate(-200px, -500px) scale(1.5) rotate(-45deg)' : 'none',
          opacity: isFlying ? 0 : 1,
          pointerEvents: isFlying ? 'none' : 'auto',
        }}
      />

    </div>
  );
}
